<template>
  <portal to="modal" :disabled="inline">
    <transition name="modal">
      <div class="modal-mask" :class="{ inline }" @click.self="onClose" @touchmove="stopScroll" @wheel="stopScroll">
        <div class="dialog">
          {{ message }}
          <footer class="footer">
            <Button class="button" secondary @click="onClose">{{ $t('close') }}</Button>
          </footer>
        </div>
      </div>
    </transition>
  </portal>
</template>

<script>
import Vue from 'vue'
import PortalVue from 'portal-vue'
import Button from '@/components/atoms/Button'

Vue.use(PortalVue)

/**
 * ダイアログ
 */
export default {
  name: 'Dialog',
  components: {
    Button,
  },
  props: {
    /** メッセージ */
    message: { type: String, required: true },
    /**
     * インライン表示（スタイルガイド用）
     * @ignore
     */
    inline: { type: Boolean, default: false },
  },
  methods: {
    stopScroll(e) {
      if (!e.target.closest('.dialog')) {
        e.preventDefault()
        e.stopPropagation()
      }
    },
    onClose() {
      /** 閉じる */
      this.$emit('close')
    },
  },
}
</script>

<style lang="postcss" scoped>
.modal-mask {
  align-items: center;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  height: 100vh;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  transition: opacity 0.3s ease;
  white-space: pre-line;
  width: 100%;
  z-index: 2;

  &.inline {
    height: 480px;
    position: static;
    width: auto;
  }
}

.dialog {
  background: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-items: center;
  max-height: calc(100% - 32px);
  padding: 32px 16px;
  text-align: center;
  transition: all 0.3s ease;
  width: calc(100% - 32px);

  @media screen and (min-width: 512px) {
    padding: 32px;
    width: 480px;
  }
}

.footer {
  display: flex;
  margin-top: 32px;
  width: 100%;

  @media screen and (min-width: 512px) {
    justify-content: center;
  }
}

.button {
  @media screen and (min-width: 512px) {
    width: 160px;
  }
}

/* 以下 transition 用 */
.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}
</style>
